import { TApplicationState } from '../../types/redux';

export function getNewbuildingWebsite(state: TApplicationState) {
  const {
    newbuilding: { website },
  } = state;

  return website;
}
